import { render, staticRenderFns } from "./edit-phone.vue?vue&type=template&id=4d48a4cc&scoped=true&"
import script from "./edit-phone.vue?vue&type=script&lang=js&"
export * from "./edit-phone.vue?vue&type=script&lang=js&"
import style0 from "./edit-phone.vue?vue&type=style&index=0&id=4d48a4cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48a4cc",
  null
  
)

export default component.exports